import {Injectable} from '@angular/core';

import {ICepResponseData, ICityResponseData} from '../../interfaces/ICepResponse';
import {BaseService} from "../caronte-base/base.service";
import {RouteUtils} from "../../../utils/route.utils";

@Injectable({
  providedIn: 'root',
})
export class CepService {


  constructor(
    private baseService: BaseService,
  ) {
  }

  getCepInformation(cepCode: string) {
    return this.baseService.get<ICepResponseData>(RouteUtils.ENTRYPOINTS.GET_ADDRESS, {zipCode: cepCode});
  }

  getCities(uf: string) {
    return this.baseService.get<ICityResponseData>(RouteUtils.ENTRYPOINTS.GET_CITIES, {uf});
  }
}
